import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import VCurrencyField from 'v-currency-field'
import IdleVue from 'idle-vue'

import { VTextField } from 'vuetify/lib'  //Globally import VTextField

Vue.component('v-text-field', VTextField)

Vue.use(VCurrencyField, {
  locale: 'nb-NO',
  decimalLength: 2,
  autoDecimalMode: false,
  min: null,
  max: null,
  valueAsInteger: false,
  allowNegative: true
})
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.use(IdleVue, { 
  idleTime: 600000,
  store })

Vue.$cookies.config('7d')

// Import the Auth0 configuration
// import { domain, clientId, audience } from "../auth_config";

// Import the plugin here
// import { Auth0Plugin } from "./auth";

Vue.config.productionTip = false

// Install the authentication plugin here
/* Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});
 */


new Vue({
  store,
  vuetify,
  router,
  async created() {
    await this.$store.dispatch('showLoader')
    await this.$store.dispatch('initHeaders')
  },
  render: h => h(App)
}).$mount('#app')
